module.exports = __webpack_public_path__ + "static/assets/d8cbb86bdb5ce2ba9f2ed0975f51231e.svg";